module.exports = __webpack_public_path__ + "img/avatar_default_3.9948375a.svg";